import React from 'react'
import {ManageMemberButton} from './ManageMemberButton'

export interface Tab {
  id: string
  label: string
  badge?: number
}

interface TabNavigationProps {
  tabs: Tab[]
  activeTab: string
  onTabChange: (tabId: string) => void
  onCreateRecord?: () => void
}

export const ManageMemberTabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  activeTab,
  onTabChange,
  onCreateRecord,
}) => {
  

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '20px',
      }}
    >
      <div className='tab-navigation'>
        {(tabs || []).map((tab:any, index:number) => (<div key={tab.id} className='d-flex flex-row'>
          <div className={`tab-navigation__item ${activeTab === tab.id ? 'tab-navigation__item--selected' : ''}`}
            onClick={()=>onTabChange(tab.id)}
          >
            <div className='tab-navigation__label'>{tab.label}</div>
          </div>
          <li className={`separator-vertical ${index < tabs.length - 1 ? 'd-flex' : 'd-none'}`}>
            <hr />
          </li>
        </div>))}
      </div>

      <ManageMemberButton
        label='Create Member'
        icon='calendar-edit'
        variant='outline'
        state={{isNewRecord: true}}
      />
    </div>
  )
}
